module.exports = __webpack_public_path__ + "static/img/mastercard.c4bf32b2.svg";